import React, { useEffect, useState } from "react";
import { axiosSalary } from "../api/axiosInstance";
import { useAuth } from "../auth/AuthContext";

const ReplaceSessionByManager = ({ open, onClose, rowData, onSuccess }) => {

  const { user } = useAuth();

  const [form, setForm] = useState({
    sessionId: "",
    inTime: "",
    outTime: "",
    reason: ""
  });

  /* ================= FETCH LAST SESSION ================= */
  useEffect(() => {
    const fetchAttendance = async () => {
      try {
        const res = await axiosSalary.get(
          `/DailyAttendance/GetAttendanceForManagerEdit`,
          {
            params: {
              groupId: user?.groupId,
              restId: rowData.restId,
              empId: rowData?.empId,
              attendanceDate: new Date(
                rowData.attendanceDate.split("/").reverse().join("-")
              ).toISOString(),
            },
          }
        );

        const data = res.data;

        if (data?.sessions?.length) {
          const lastSession = data.sessions[data.sessions.length - 1];

         setForm({
  sessionId: lastSession.sessionId || "",
  inTime: convertISTToInput(lastSession.inTimeIst),   // ✅ FIXED
  outTime: lastSession.outTimeIst
    ? convertISTToInput(lastSession.outTimeIst)
    : "",
  reason: data?.lastManualEditReason || ""
});
        }

      } catch (err) {
        console.error("Fetch attendance error:", err);
      }
    };

    if (open && rowData) {
      fetchAttendance();
    }
  }, [open, rowData, user]);

const convertISTToInput = (istString) => {
  if (!istString) return "";

  const [datePart, timePart, modifier] = istString.split(" ");

  const [day, month, year] = datePart.split("/");
  let [hours, minutes] = timePart.split(":");

  hours = parseInt(hours);

  if (modifier === "PM" && hours !== 12) {
    hours += 12;
  }
  if (modifier === "AM" && hours === 12) {
    hours = 0;
  }

  return `${year}-${month}-${day}T${String(hours).padStart(2, "0")}:${minutes}`;
};

  /* ================= SUBMIT ================= */
  const handleSubmit = async () => {

    if (!form.inTime || !form.outTime) {
      alert("Please enter both In Time and Out Time");
      return;
    }

    if (new Date(form.outTime) <= new Date(form.inTime)) {
      alert("Out Time must be greater than In Time");
      return;
    }

    try {

      const payload = {
        groupId: user?.groupId,
        restId: rowData.restId,
        empId: rowData.empId,

        attendanceDate: new Date(
          rowData.attendanceDate.split("/").reverse().join("-")
        ).toISOString(),

       session: {
  sessionId: form.sessionId,
  inTimeUtc: new Date(form.inTime).toISOString(),  // ✅ FIX
  outTimeUtc: new Date(form.outTime).toISOString(),
},

        userId: user?.userId,
        reason: form.reason
      };

      await axiosSalary.post(
        "/DailyAttendance/ReplaceSessionByManager",
        payload
      );

      alert("Session replaced successfully");

      onClose();
      onSuccess && onSuccess();

    } catch (err) {
      console.error("Replace session error:", err);
      alert("Failed to replace session");
    }
  };

  if (!open) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center z-50">

      <div className="bg-white rounded-lg p-4 w-[320px]">

        <h3 className="font-semibold mb-3">
          Replace Session - {rowData?.empName}
        </h3>

        <div className="space-y-2 text-sm">

          {/* IN TIME */}
          <input
            type="datetime-local"
            value={form.inTime}
            onChange={(e) =>
              setForm({ ...form, inTime: e.target.value })
            }
            className="w-full border p-2 rounded "
          
          />

          {/* OUT TIME */}
          <input
            type="datetime-local"
            value={form.outTime}
            onChange={(e) =>
              setForm({ ...form, outTime: e.target.value })
            }
            className="w-full border p-2 rounded"
          />

          {/* REASON */}
          <textarea
            placeholder="Reason"
            value={form.reason}
            onChange={(e) =>
              setForm({ ...form, reason: e.target.value })
            }
            className="w-full border p-2 rounded"
          />

        </div>

        <div className="flex justify-end gap-2 mt-3">

          <button
            onClick={onClose}
            className="px-3 py-1 border rounded"
          >
            Cancel
          </button>

          <button
            onClick={handleSubmit}
            className="px-3 py-1 bg-orange-600 text-white rounded"
          >
            Replace
          </button>

        </div>

      </div>

    </div>
  );
};

export default ReplaceSessionByManager;